import { useState } from "react";
import { motion } from "framer-motion";
import { FiSend } from "react-icons/fi";
import emailjs from "@emailjs/browser";

export default function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .send(
        "service_8ucdrxk",
        "template_stc1x4j",
        formData,
        "zKIcnao_nR-BFQXwW"
      )
      .then(
        () => {
          setSubmitted(true);
          setFormData({ name: "", email: "", message: "" });
        },
        (error) => {
          alert("Failed to send message 😢");
          console.error(error);
        }
      );
  };

  return (
    <section className="py-24 px-5 md:px-10 flex flex-col items-center">
      <div className="text-center mb-12">
        <p className="text-violet-400 text-sm font-medium tracking-widest uppercase mb-2">
          Get in touch
        </p>
        <h2 className="text-3xl md:text-4xl font-bold grad-text">Contact Me</h2>
        <p className="text-gray-400 max-w-xl mx-auto mt-4 text-sm md:text-base">
          Have a project in mind or just want to say hello? Send me a message
          and I'll get back to you.
        </p>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="w-full max-w-xl"
      >
        {submitted && (
          <div className="mb-4 p-4 bg-gradient-to-r from-violet-500 to-blue-500 text-white rounded-xl text-center font-medium">
            ✅ Message sent successfully!
          </div>
        )}

        <form
          onSubmit={handleSubmit}
          className="glass p-6 sm:p-8 rounded-3xl shadow-xl space-y-5"
        >
          <div>
            <label className="block text-sm text-gray-300 mb-2">Full Name</label>
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
              className="w-full p-3 rounded-xl bg-black/40 border border-white/10 text-white placeholder-gray-500 focus:outline-none focus:border-violet-400/60 transition"
            />
          </div>

          <div>
            <label className="block text-sm text-gray-300 mb-2">Email</label>
            <input
              type="email"
              name="email"
              placeholder="your@email.com"
              value={formData.email}
              onChange={handleChange}
              required
              className="w-full p-3 rounded-xl bg-black/40 border border-white/10 text-white placeholder-gray-500 focus:outline-none focus:border-violet-400/60 transition"
            />
          </div>

          <div>
            <label className="block text-sm text-gray-300 mb-2">Message</label>
            <textarea
              name="message"
              placeholder="Write your message..."
              value={formData.message}
              onChange={handleChange}
              rows="5"
              required
              className="w-full p-3 rounded-xl bg-black/40 border border-white/10 text-white placeholder-gray-500 focus:outline-none focus:border-violet-400/60 transition resize-none"
            ></textarea>
          </div>

          <button
            type="submit"
            className="w-full py-3 flex items-center justify-center gap-2 bg-gradient-to-r from-violet-500 to-blue-500 hover:scale-[1.02] rounded-xl font-semibold text-white shadow-lg shadow-violet-500/25 transition-transform"
          >
            <FiSend /> Send Message
          </button>
        </form>
      </motion.div>
    </section>
  );
}
